import clsx from 'clsx';

const sizes = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

const sealFill = {
  default: '#10b981',
  onDark: '#ffffff',
} as const;

const checkFill = {
  default: '#ffffff',
  onDark: '#14532d',
} as const;

/** Meta-style verified seal — green badge with white checkmark; onDark = white seal + green check */
export function VerifiedBadge({
  className,
  size = 'md',
  variant = 'default',
  title = 'Verified seller',
}: {
  className?: string;
  size?: keyof typeof sizes;
  variant?: keyof typeof sealFill;
  title?: string;
}) {
  return (
    <span
      className={clsx('inline-flex shrink-0 align-middle', className)}
      title={title}
      aria-label={title}
      role="img"
    >
      <svg
        viewBox="0 0 40 40"
        className={clsx(sizes[size], variant === 'onDark' && 'drop-shadow-sm')}
        aria-hidden
      >
        <path
          fill={sealFill[variant]}
          d="M19.998 3.094 14.638 0l-2.972 5.15H5.32v6.352L0 14.64 3.094 20 0 25.359l5.15 2.972v6.353h6.346L14.64 40l5.358-3.094L25.358 40l2.972-5.15h6.346v-6.353L40 25.36 36.905 20 40 14.641l-5.15-2.972V5.32h-6.346L25.36 0l-5.362 3.094Z"
        />
        <path
          fill={checkFill[variant]}
          d="m17.09 26.09-5.66-5.65 2.12-2.12 3.54 3.54 8.38-8.39 2.12 2.12-10.5 10.5Z"
        />
      </svg>
    </span>
  );
}
